(function () {
  'use strict';
  var REGEX_ORIG = /\u27E6ORIG:([A-Za-z]{2})\u27E7([\s\S]*?)\u27E6\/ORIG\u27E7/;
  var LANGUES = {
    ES:'espagnol', EN:'anglais', PT:'portugais', DE:'allemand', IT:'italien',
    NL:'néerlandais', PL:'polonais', RU:'russe', TR:'turc', AR:'arabe',
    ZH:'chinois', JA:'japonais', KO:'coréen'
  };
  function nomLangue(code){ return LANGUES[String(code).toUpperCase()] || String(code).toUpperCase(); }

  document.addEventListener('click', function(e){
    var bouton = e.target && e.target.closest ? e.target.closest('.pp-avis-toggle') : null;
    if (!bouton) return;
    var conteneur = bouton.parentElement;
    if (!conteneur) return;
    var blocOrig = conteneur.querySelector('.pp-avis-original');
    if (!blocOrig) return;
    var ouvert = !blocOrig.hidden;
    blocOrig.hidden = ouvert;
    bouton.textContent = ouvert ? bouton.getAttribute('data-libelle-affiche') : bouton.getAttribute('data-libelle-masque');
    bouton.setAttribute('aria-expanded', String(!ouvert));
  }, true);

  function libererHauteur(el){
    var courant = el;
    for (var i = 0; i < 6 && courant && courant.nodeType === 1; i++){
      courant.style.setProperty('max-height', 'none', 'important');
      courant.style.setProperty('height', 'auto', 'important');
      courant.style.setProperty('overflow', 'visible', 'important');
      courant.style.setProperty('-webkit-line-clamp', 'unset', 'important');
      if (courant.id === 'judgeme_product_reviews' ||
          (courant.classList && courant.classList.contains('jdgm-widget'))) break;
      courant = courant.parentElement;
    }
  }

  function traiterAvis(el){
    var html = el.innerHTML;
    if (html.indexOf('\u27E6') === -1) return;
    var m = html.match(REGEX_ORIG);
    if (!m) return;
    var langue = nomLangue(m[1]);
    var original = m[2].trim();
    var traduction = html.replace(m[0],'').trim();
    var libelleAffiche = 'Voir l\u2019avis original (' + langue + ')';
    var libelleMasque = 'Masquer l\u2019original';
    el.innerHTML = '';
    var blocFr = document.createElement('div');
    blocFr.className = 'pp-avis-fr';
    blocFr.innerHTML = traduction;
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'pp-avis-toggle';
    bouton.textContent = libelleAffiche;
    bouton.setAttribute('aria-expanded','false');
    bouton.setAttribute('data-libelle-affiche', libelleAffiche);
    bouton.setAttribute('data-libelle-masque', libelleMasque);
    var blocOrig = document.createElement('div');
    blocOrig.className = 'pp-avis-original';
    blocOrig.setAttribute('lang', String(m[1]).toLowerCase());
    blocOrig.hidden = true;
    blocOrig.innerHTML = original;
    el.appendChild(blocFr);
    el.appendChild(bouton);
    el.appendChild(blocOrig);
    libererHauteur(el);
  }

  var SELECTEUR = '.jdgm-review-content__body-content, .jdgm-rev__body';

  function feuilleSous(c){
    var cible = c;
    while (cible.children.length === 1 && !cible.classList.contains('pp-avis-fr')) {
      cible = cible.children[0];
    }
    if (cible.children.length > 0) return null;
    return cible;
  }

  function candidats(){
    var conteneurs = document.querySelectorAll(SELECTEUR);
    var resultat = [];
    for (var i=0;i<conteneurs.length;i++){
      var c = conteneurs[i];
      var carte = c.closest('[class*="jm-review-item"]') || c.parentElement;
      if (carte && carte.querySelector('.jm-review-content__expand-button')) continue;
      var f = feuilleSous(c);
      if (f) resultat.push(f);
    }
    return resultat;
  }

  var enAttente = false;
  function scannerDifféré(){
    if (enAttente) return;
    enAttente = true;
    setTimeout(function(){
      candidats().forEach(traiterAvis);
      setTimeout(function(){
        candidats().forEach(traiterAvis);
        enAttente = false;
      }, 500);
    }, 400);
  }

  document.addEventListener('click', function(e){
    var dansWidget = e.target && e.target.closest
      ? e.target.closest('#judgeme_product_reviews, .jdgm-widget')
      : null;
    if (!dansWidget) return;
    if (e.target.closest('.pp-avis-toggle')) return;
    scannerDifféré();
  }, true);

  function demarrer(){
    candidats().forEach(traiterAvis);
    [800, 2000, 4000, 7000].forEach(function(delai){
      setTimeout(function(){ candidats().forEach(traiterAvis); }, delai);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
